import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiTrendingUp, FiBox, FiFilter, FiUsers, FiCpu } from 'react-icons/fi';
import { SectionHeading } from '../ui/SectionHeading';

const Card = ({ title, icon: Icon, delay }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ delay }}
    className="bg-navy-800/50 backdrop-blur-sm border border-white/5 hover:border-royal-500/30 rounded-2xl p-8 transition-all duration-300 group hover:bg-navy-800"
  >
    <div className="w-14 h-14 rounded-xl bg-royal-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
      <SafeIcon icon={Icon} className="text-2xl text-royal-400" />
    </div>
    <h4 className="text-xl font-bold text-white group-hover:text-royal-400 transition-colors">{title}</h4>
  </motion.div>
);

export const WhatYouBuild = () => {
  const builds = [
    { title: "Your first ₹1 Lakh online income", icon: FiTrendingUp },
    { title: "Your digital product", icon: FiBox },
    { title: "Your funnel system", icon: FiFilter },
    { title: "Your lead generation system", icon: FiUsers },
    { title: "Your automated sales system", icon: FiCpu },
  ];

  return (
    <section className="py-24 px-4 bg-[#0B0E14] relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-royal-600/5 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        <SectionHeading highlight="Silver 2.0">
          What You Can Achieve with
        </SectionHeading>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {builds.map((build, idx) => (
            <Card key={idx} {...build} delay={idx * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
};